
import React, { Component, useRef } from "react";
import { Modal } from "react-bootstrap";
import Navbar from "../../../components/Navbar.js";
import Select from "react-select";
import LOGO from "../../../assets/images/logo.png";
import SignatureCanvas from 'react-signature-canvas';
import Pagination from '@mui/material/Pagination';
import BarcodeComponent from '../../../components/BarcodeComponent';

import {
    locale,
    tokens,
    select_style,
    required,
    // alert
    success,
    success_url,
    alert,
    alert_url,
    // function
    logout,
    number_zero,
    format_date,
    toFixed,
    total,
    validate,
    random_charactor,
    float,
    // api
    GET,
    POST,
    PUT,
    DELETE,
    error_message,
    // storage
    removeStorage,
    getStorage,

    validate_email,
    validate_th,
    validate_en,
    validate_en_number,

    LinktoBase64,
    // component
    DatePicker,
} from "../../../components/CustomComponent.js";

import "../../../components/global.js";
import "../../../assets/css/bootstrap.css";
import "../../../assets/css/index.css";

export default class ListBarcodeForSpare extends Component {
    constructor(props) {
        super(props)
        this.state = {
            modal_delete: false,
            modal_add: false,
            modal_barcode_custom: false,

            loading: false,
            data: null,
            barcode_config: {
                paper_size: '100x100',
                show_code: false,
                show_name: false,
                show_price: false,
                show_lot: false,
            },

            product_id: "",
            product_code: "",
            product_name: "",
            product_type: "",

            barcode_code: "",
            barcode_name: "",
            barcode_price: "",
            barcode_lot: "",

            sale_price: 0,
            cost_price: 0,
            description: "",

            page: 1,
            data_search: ""

        }
    }

    async componentDidMount() {
        await this.Get();
        await this.GetBarcodeConfig();
        this.handlePrint = (width,height,index) => {
            console.log('Printing')  
            const printContents = document.getElementById("section-to-print-"+index).innerHTML;
            let text_size = '.justify-content-center {  margin: 10px; padding: 10px; position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); h5,p,div { margin: 0; }'

            if(height !== '100'){
                text_size = 'h5,p,div { margin: 0; padding: 0; font-size: 7px; }'
            }

            const printWindow = window.open('', '', 'height='+1000+',width='+1000);
            printWindow.document.write('<html><head>');
            printWindow.document.write('<style media="print">@page {size: '+(width)+'mm '+(height)+'mm; margin: 0; .text-barcode {margin: 0;} }  '+text_size+'} </style>');
            printWindow.document.write('</head><body>');
            printWindow.document.write(printContents);
            printWindow.document.write('</body></html>');
            printWindow.document.close();
            printWindow.focus();
            printWindow.print();
            printWindow.close();
        }
    }

    Get = async () => {
        this.setState({ loading: true });
        let body = {
            page: this.state.page,
            data_search: this.state.data_search,
            product_id: ""
        }

        console.log("body:",body);
        console.log("branch:",getStorage("branch").branch_id);
        let result = await GET(tokens, "v1/TH/product-manage/product/print/list/" + getStorage("branch").branch_id, body);
        if (result && result.status) {
            console.log("data :",result);
            this.setState({ data: result });
        }
        this.setState({ loading: false });
    }
    
    GetBarcodeConfig = async () => {
        this.setState({ loading: true });
        let body = {
            page: this.state.page,
            data_search: this.state.data_search,
            product_id: ""
        }

        let result = await GET(tokens, "v1/TH/goods-receipt/barcode/" + getStorage("branch").branch_id, body);
        if (result && result.status) {
            this.setState({ barcode_config: result.data });
        }
        this.setState({ loading: false });
    }

    render() {
        // console.log('data 2 :',this.state.data.data);
        return (
            <div className="w-100 min-vh-100 fade-in">
                {this.state.loading && (<div className="spinner-container"> <div className="loading-spinner"></div> </div>)}
                <Navbar page1="หน้าหลัก" page2="จัดการระบบ" page3="ปริ้นอะไหล่และการซ่อม" />
                {/* BODY */}
                <div className="body bg-light min-vh-100">
                    <div className="p-3">
                        {/* หัวข้อ และ ปุ่มเพิ่ม */}
                        <div className="d-flex mx-0 align-items-center justify-content-between test mb-2 flex-wrap">
                            <h3 className="mb-2"><b>ปริ้น Barcode</b></h3>
                            <div className="d-flex">
                                <button className="btn btn-outline-orange mx-1" onClick={() => { window.location.href = "/master" }}>
                                    <span className="icon me-2">{"\uf060"}</span>ย้อนกลับ
                                </button>
                                <button className="btn btn-orange mx-1" onClick={() => { this.setState({ modal_add: true }) }}>
                                    เพิ่มสินค้า
                                </button>
                                <button className="btn btn-orange mx-1" onClick={() => { this.setState({ modal_barcode_custom: true }) }}>
                                    พิมพ์บาร์โค้ด
                                </button>
                            </div>
                        </div>
                        <div className="w-100 card border-0 p-0">
                            <div className="d-flex flex-wrap mx-0 px-3 pt-3">
                                <input
                                    className="form-control wpx-250 bg-contain border-0 mx-1 mb-2"
                                    type="text"
                                    placeholder=""
                                    onChange={(e) => { this.setState({ data_search: e.target.value }) }}
                                    onKeyUp={(e) => {
                                        if (e.key === "Enter") {
                                            this.setState({ page: 1 });
                                            setTimeout(() => {
                                                this.Get();
                                            }, 10);
                                        }
                                    }}
                                    value={this.state.data_search}
                                />
                                <button className="btn btn-orange mx-1" onClick={() => {
                                    this.setState({ page: 1 });
                                    setTimeout(() => {
                                        this.Get();
                                    }, 10);
                                }}>
                                    ค้นหา
                                </button>
                                <button className="btn btn-outline-orange mx-1" onClick={() => {
                                    this.setState({ page: 1, data_search: "" });
                                    setTimeout(() => {
                                        this.Get();
                                    }, 10);
                                }}>
                                    รีเซ็ต
                                </button>
                            </div>
                            <div className="table-responsive">
                                <table className="table table-borderless table-striped">
                                    <thead className="bg-primary">
                                        <tr>
                                            <th className="text-center text-white">รหัสสินค้า</th>
                                            <th className="text-left text-white">ชื่อสินค้า</th>
                                            <th className="text-center text-white">พิมพ์</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.data && this.state.data.data.map((item, index) => (
                                            <tr key={index}>
                                                <td className="text-center">{item.product_code ? item.product_code : "-"}</td>
                                                <td className="text-left">{item.product_name ? item.product_name : "-"}</td>
                                                <td className="text-center">
                                                    <div className="w-100 d-flex justify-content-center">
                                                        <div className="pointer wpx-30 hpx-30 rounded bg-primary-light mx-1 d-flex justify-content-center align-items-center"
                                                            onClick={() => this.handlePrint(
                                                                this.state.barcode_config['paper_size'].split('x')[0],
                                                                this.state.barcode_config['paper_size'].split('x')[1],
                                                                index
                                                            )} >
                                                            <label className="pointer icon text-primary p-2">{"\uf02f"}</label>
                                                        </div>
                                                        <div style={{ display: 'none', '@media print': { display: 'block' } }} id={"section-to-print-"+index}>
                                                            <div style={{ textAlign: 'center' }}>
                                                                <BarcodeComponent 
                                                                    ref={(refer) => (this.componentRef = refer)}
                                                                    value={item.product_code}
                                                                    show_code={this.state.barcode_config['show_code']}
                                                                    show_name={this.state.barcode_config['show_name']}
                                                                    show_price={this.state.barcode_config['show_price']}
                                                                    show_lot={this.state.barcode_config['show_lot']}
                                                                    code={item.product_code}
                                                                    name={item.product_name}
                                                                    price={""}
                                                                    lot={""}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                                {/* pagination */}
                                {this.state.data && (
                                    <div className="d-flex flex-wrap justify-content-between w-100 px-3 mt-3">
                                        <label>
                                            แสดง {this.state.data.end_index} รายการ จาก {this.state.data.count} รายการ
                                        </label>
                                        <Pagination
                                            count={this.state.data.page_number}
                                            page={this.state.data.page}
                                            color="primary"
                                            showFirstButton
                                            shape="rounded"
                                            showLastButton
                                            onChange={(event, value) => {
                                                this.setState({ page: value })
                                                setTimeout(() => { this.Get() }, 5)
                                            }} />
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
                {/* ลบข้อมูล */}
                <Modal show={this.state.modal_add} onHide={() => { this.setState({ modal_add: false }) }}>
                    <Modal.Header> <Modal.Title> <b>คุณต้องการเพิ่มสินค้าประเภทใด</b> </Modal.Title> </Modal.Header>
                    <Modal.Body>
                        <div className="row">
                            <div className="col-6">
                                <div className="w-100 hpx-150 me-3 mb-2 card pointer rounded-lg border-0 shadow py-3 px-1 d-flex align-items-center justify-content-center hover-primary"
                                    onClick={() => { window.location.href = "/master/spare-parts-repair/create?type=อะไหล่" }}
                                >
                                    <div className="wpx-80 hpx-80 mb-2 rounded-circle bg-primary-light d-flex align-items-center justify-content-center text-primary">
                                        <span className="icon text-32">{"\uf7d9"}</span>
                                    </div>
                                    <label>อะไหล่</label>
                                </div>
                            </div>
                            <div className="col-6">
                                <div className="w-100 hpx-150 me-3 mb-2 card pointer rounded-lg border-0 shadow py-3 px-1 d-flex align-items-center justify-content-center hover-primary"
                                    onClick={() => { window.location.href = "/master/spare-parts-repair/create?type=การซ่อม" }}
                                >
                                    <div className="wpx-80 hpx-80 mb-2 rounded-circle bg-primary-light d-flex align-items-center justify-content-center text-primary">
                                        <span className="icon text-32">{"\uf4fe"}</span>
                                    </div>
                                    <label>การซ่อม</label>
                                </div>
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <div className="w-100 d-flex justify-content-center">
                            <button className="btn btn-outline-orange px-4" onClick={() => { this.setState({ modal_add: false }) }}>
                                ยกเลิก
                            </button>
                        </div>
                    </Modal.Footer>
                </Modal>
                {/* ลบข้อมูล */}
                <Modal show={this.state.modal_barcode_custom} onHide={() => { this.setState({ modal_barcode_custom: false }) }}>
                    <Modal.Header> <Modal.Title> <b>พิมพ์บาร์โค้ด</b> </Modal.Title> </Modal.Header>
                    <Modal.Body>
                        <div className="row">
                            <div id="section-to-print-custom" >
                                <div style={{ textAlign: 'center' }}>
                                    <BarcodeComponent 
                                        ref={(refer) => (this.componentRef = refer)}
                                        value={this.state.barcode_code}
                                        show_code={this.state.barcode_config['show_code']}
                                        show_name={this.state.barcode_config['show_name']}
                                        show_price={this.state.barcode_config['show_price']}
                                        show_lot={this.state.barcode_config['show_lot']}
                                        code={this.state.barcode_code}
                                        name={this.state.barcode_name}
                                        price={this.state.barcode_price}
                                        lot={this.state.barcode_lot}
                                    />
                                </div>
                            </div>
                            { 
                            this.state.barcode_config['show_code'] ? (
                                <div className="col-12 mt-2" >
                                    <label>รหัสสินค้า</label>
                                    <input
                                        className="form-control w-100"
                                        type="text"
                                        placeholder=""
                                        onChange={(e) => { this.setState({ barcode_code: e.target.value }) }}
                                        value={this.state.barcode_code}
                                    />
                                </div>
                            ) : null }
                            { 
                            this.state.barcode_config['show_name'] ? (
                                <div className="col-12 mt-2" >
                                    <label>ชื่อสินค้า</label>
                                    <input
                                        className="form-control w-100"
                                        type="text"
                                        placeholder=""
                                        onChange={(e) => { this.setState({ barcode_name: e.target.value }) }}
                                        value={this.state.barcode_name}
                                    />
                                </div>
                            ) : null }
                            { 
                            this.state.barcode_config['show_price'] ? (
                                <div className="col-12 mt-2" >
                                    <label>ราคา</label>
                                    <input
                                        className="form-control w-100"
                                        type="text"
                                        placeholder=""
                                        onChange={(e) => { this.setState({ barcode_price: e.target.value }) }}
                                        value={this.state.barcode_price}
                                    />
                                </div>
                            ) : null }
                            { 
                            this.state.barcode_config['show_lot'] ? (
                                <div className="col-12 mt-2" >
                                    <label>Lot</label>
                                    <input
                                        className="form-control w-100"
                                        type="text"
                                        placeholder=""
                                        onChange={(e) => { this.setState({ barcode_lot: e.target.value }) }}
                                        value={this.state.barcode_lot}
                                    />
                                </div>
                            ) : null }
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <div className="w-100 d-flex justify-content-center">
                            <button className="btn btn-outline-orange px-4 mx-1" onClick={() => { this.setState({ modal_barcode_custom: false }) }}>
                                ยกเลิก
                            </button>
                            <button className="btn btn-orange px-4" 
                                onClick={() => this.handlePrint(
                                    this.state.barcode_config['paper_size'].split('x')[0],
                                    this.state.barcode_config['paper_size'].split('x')[1],
                                    'custom'
                                )} >
                                พิมพ์
                            </button>
                        </div>
                    </Modal.Footer>
                </Modal>
                {/* ลบข้อมูล */}
                <Modal show={this.state.modal_delete} onHide={() => { this.setState({ modal_delete: false }) }}>
                    <Modal.Header> <Modal.Title> <b>ต้องการลบสินค้า</b> </Modal.Title> </Modal.Header>
                    <Modal.Body>
                        <label>
                            ท่านต้องการลบสินค้า “{this.state.product_name}”
                        </label>
                    </Modal.Body>
                    <Modal.Footer>
                        <label className="mb-2 w-100">
                            หมายเหตุ ไม่สามารถกู้คืนได้
                        </label>
                        <div className="w-100 d-flex">
                            <div className="w-50 pe-1">
                                <button className="btn btn-danger w-100" onClick={() => { this.DeleteProduct() }}>
                                    ลบ
                                </button>
                            </div>
                            <div className="w-50 ps-1">
                                <button className="btn btn-outline-danger w-100" onClick={() => { this.setState({ modal_delete: false }) }}>
                                    ยกเลิก
                                </button>
                            </div>
                        </div>
                    </Modal.Footer>
                </Modal>
            </div >
        )
    }
}